export const SCREEN_HEIGHT_IN_PX = 1080;
export const SCREEN_WIDTH_IN_PX = 1920;
export const GUIDE_WINDOW_DAYS_IN_PAST = 7;
export const GUIDE_WINDOW_DAYS_IN_FUTURE = 7;
export const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000; // one day = hours*minutes*seconds*milliseconds
